import { render, staticRenderFns } from "./message-form.vue?vue&type=template&id=ab5f83a8&"
import script from "./message-form.vue?vue&type=script&lang=js&"
export * from "./message-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports